"use client"

import { Stack } from "@mantine/core"
import { usePathname } from "next/navigation"

import { useAppStore } from "@/app/(store)/appStore"
import { NavbarContactsButton } from "@/components/generic/SideNavBar/components/NavbarContactsButton"
import { NavbarDevToolsButton } from "@/components/generic/SideNavBar/components/NavbarDevToolsButton"
// import { NavbarHomeButton } from "@/components/generic/SideNavBar/components/NavbarHomeButton"
// import { NavbarMenuToggle } from "@/components/generic/SideNavBar/components/NavbarMenuToggle"
import { NavbarTemplatesButton } from "@/components/generic/SideNavBar/components/NavbarTemplatesButton"
import { cn } from "@/lib/utils"
import { NavbarOptionButton } from "@/components/generic/SideNavBar/components/NavbarOptionButton"
import { IconRouteSquare } from "@tabler/icons-react"
import { NavbarPowerDialerButton } from "@/components/generic/SideNavBar/components/NavbarPowerDialerButton"
import dynamic from "next/dynamic"

const NavbarOptionHome = dynamic(
  () =>
    import("@/components/generic/SideNavBar/components/clientComponents").then(
      (mod) => mod.NavbarOptionHome
    ),
  {
    ssr: false,
  }
)

const NavbarOptionStats = dynamic(
  () =>
    import("@/components/generic/SideNavBar/components/clientComponents").then(
      (mod) => mod.NavbarOptionStats
    ),
  {
    ssr: false,
  }
)

const NavbarOptionLiveMonitor = dynamic(
  () =>
    import("@/components/generic/SideNavBar/components/clientComponents").then(
      (mod) => mod.NavbarOptionLiveMonitor
    ),
  {
    ssr: false,
  }
)

const BASE_TEST_ID = "sidenavbar-"

const menuOptions = {
  Home: "/messenger",
  PowerDialer: "/power-dialer",
  Stats: "/stats",
  LiveMonitor: "/live-monitor",
  EmailTemplatesLibrary: "/templates/email/library",
  EmailTemplatesComposer: "/templates/email/compose",
  SMSTemplatesLibrary: "/templates/sms/library",
  SMSTemplatesComposer: "/templates/sms/compose",
  CallScriptsLibrary: "/call/scripts",
  TemplatesLibrary: "/templates/library",
  ContactPropertiesLibrary: "/contact/properties/library",
  ContactListsLibrary: "/contact/lists/library",
  ContactBulkEditor: "/contact/bulk/editor",
  SequenceListsLibrary: "/sequences/library",
  ScheduledCalls: "/scheduled/calls",
  Settings: "/settings",
  DevTools: "/dev",
}

export function SideNavBar() {
  const pathName = usePathname()
  const { changeSidebarMenuState, isSidebarMenuExpanded } = useAppStore()
  return (
    <>
      <nav
        className={cn(
          "flex h-full w-14 flex-1 flex-col bg-r-blue pb-4 dark:bg-r-blue-dark-mode",
          isSidebarMenuExpanded ? "w-82 absolute z-20 shadow" : ""
        )}
        data-testid={`${BASE_TEST_ID}container`}
      >
        {/* <div className="flex h-16 items-center justify-start pl-1">
          <NavbarMenuToggle />
        </div> */}
        <div
          className={cn("flex-1", isSidebarMenuExpanded ? "pl-1 pr-6" : "px-4")}
        >
          <Stack justify="center" gap={8}>
            {/* Home: / & /messenger */}
            <NavbarOptionHome
              isSelected={pathName === menuOptions.Home}
              isSidebarMenuExpanded={isSidebarMenuExpanded}
            />

            {/* Power Dialer: /power-dialer & /scheduled/calls */}
            <NavbarPowerDialerButton
              isSidebarMenuExpanded={isSidebarMenuExpanded}
              isSelected={
                pathName.includes(menuOptions.PowerDialer) ||
                pathName.includes(menuOptions.ScheduledCalls)
              }
            />

            {/* Contacts: /contact/* */}
            <NavbarContactsButton
              isSidebarMenuExpanded={isSidebarMenuExpanded}
              isSelected={
                pathName.includes(menuOptions.ContactListsLibrary) ||
                pathName.includes(menuOptions.ContactPropertiesLibrary) ||
                pathName.includes(menuOptions.ContactBulkEditor)
              }
            />

            {/* Content: /templates/email/library & /templates/sms/library & /call/scripts */}
            <NavbarTemplatesButton
              isSidebarMenuExpanded={isSidebarMenuExpanded}
              isSelected={
                pathName.includes(menuOptions.EmailTemplatesLibrary) ||
                pathName.includes(menuOptions.SMSTemplatesLibrary) ||
                pathName.includes(menuOptions.CallScriptsLibrary) ||
                pathName.includes(menuOptions.EmailTemplatesComposer) ||
                pathName.includes(menuOptions.SMSTemplatesComposer)
              }
            />

            {/* Sequences: /sequences/library */}
            <NavbarOptionButton
              icon={IconRouteSquare}
              isSelected={pathName.includes(menuOptions.SequenceListsLibrary)}
              isSidebarMenuExpanded={isSidebarMenuExpanded}
              label="Sequences"
              href="/sequences/library"
            />

            {/* Stats: /stats */}
            <NavbarOptionStats
              isSidebarMenuExpanded={isSidebarMenuExpanded}
              isSelected={pathName.includes(menuOptions.Stats)}
            />

            {/* Live Monitor: /live-monitor */}
            <NavbarOptionLiveMonitor
              isSidebarMenuExpanded={isSidebarMenuExpanded}
              isSelected={pathName.includes(menuOptions.LiveMonitor)}
            />
          </Stack>
        </div>

        <Stack justify="center" gap={8}>
          <NavbarDevToolsButton
            isSidebarMenuExpanded={isSidebarMenuExpanded}
            isSelected={pathName.includes(menuOptions.DevTools)}
          />
          {/* <NavbarSettingsButton
            isSidebarMenuExpanded={isSidebarMenuExpanded}
            isSelected={pathName.includes(menuOptions.Settings)}
          /> */}
          {/* {isDJUIEnabled() && (
            <NavbarOptionButton
              icon={IconSettings}
              isSelected={pathName.includes(menuOptions.Settings)}
              isSidebarMenuExpanded={isSidebarMenuExpanded}
              label="Personal Settings"
              href="/settings"
            />
          )} */}
        </Stack>
      </nav>
      <div
        data-testid={`${BASE_TEST_ID}-hide-expanded-bar-btn`}
        className={cn(
          isSidebarMenuExpanded
            ? "pointer-events-auto visible absolute inset-0 !z-[8001] cursor-pointer backdrop-blur-sm backdrop-brightness-75 transition-all"
            : "pointer-events-none invisible z-0"
        )}
        onClick={() => changeSidebarMenuState(false)}
      />
    </>
  )
}
